import { useMemo } from "react";
import { useMediaQuery } from "@/lib/hooks/ui/use-media-query";
import { useRoleCheck } from "@/lib/hooks/auth/useRoleCheck";
import { useAuthenticatedUser } from "@/lib/hooks/auth/use-authenticated-user";

/**
 * Auth and permission logic for UniversalEntityPage
 * Extracts authentication, authorization, and responsive behavior
 */
export function useUniversalEntityPageAuth() {
  // Auth hooks
  // `appUser` is dep #1 of the `auth` slice in `useCompositionStableSlices`, so
  // it MUST be referentially stable — that is what `useAuthenticatedUser` buys.
  const {
    appUser,
    isAuthenticated,
    isClientUser,
    isLoading: authLoading,
  } = useAuthenticatedUser();
  const { isEmployee, isAdmin, isWTCCRM, isWTCEmployee, isAdmin: isAdminRole } = useRoleCheck();

  // Responsive behavior
  const isMobile = useMediaQuery("(max-width: 768px)");

  // Permission calculations
  const canCreate = useMemo(() => {
    if (isWTCCRM || isAdminRole) return true;
    const employeeCreateEntities = ["tickets", "time_entries", "tasks"];
    // Note: entityName will be passed separately, so we can't check it here
    // This will be computed in the handlers hook instead
    return isWTCEmployee;
  }, [isWTCCRM, isAdminRole, isWTCEmployee]);

  return {
    appUser,
    isAuthenticated,
    isClientUser,
    authLoading,
    isEmployee,
    isAdmin,
    isWTCCRM,
    isWTCEmployee,
    isAdminRole,
    isMobile,
    canCreate,
  };
}
